import { Component, OnInit, signal, ViewChild } from '@angular/core';
import { AccountRegistrationService } from '../../../services/account-registration.service';
import { ActivatedRoute } from '@angular/router';
import { Constants, ICountry, ILookup } from 'common';
import { MatAccordion } from '@angular/material/expansion';
import { validationGroup } from '../constants/registration.constants';

@Component({
  selector: 'acc-registration-financial-details',
  templateUrl: './financial-details.component.html',
  styleUrl: './financial-details.component.scss',
})
export class FinancialDetailsComponent implements OnInit {
  validationGroup = validationGroup;
  salutations: ILookup[];
  countries: ICountry[];
  counties: ILookup[];

  get formFinancialDetails() {
    return this.accountRegistrationService.formFinancialDetails;
  }

  constructor(
    private readonly accountRegistrationService: AccountRegistrationService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.salutations = this.route.snapshot.data.salutations;
    this.countries = this.route.snapshot.data.countries;
    this.counties = this.route.snapshot.data.counties;
  }

  showHeaderError = (group: string[]): boolean =>
    group.some((prop) => {
      const control = this.formFinancialDetails?.get(prop);
      return control?.invalid && control?.touched;
    });

  countryChanged(value: string) {
    if (value.toLowerCase() === Constants.irelandCountryString.toLocaleLowerCase()) {
      this.formFinancialDetails.controls.county.enable();
    } else {
      this.formFinancialDetails.controls.county.setValue(null);
      this.formFinancialDetails.controls.county.disable();
    }
  }

  copyGeneralToFinancial() {
    this.accountRegistrationService.copyGeneralToFinancial();
    this.countryChanged(this.formFinancialDetails.controls.country.value);
  }
}
